var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChartCloudBase = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#EA9858",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "m19.185 6.674.158.787q2.12-.404 2.57-.402c1.984 0 3.508 1.67 3.508 3.647 0 2-1.906 3.605-3.866 3.605H8.028c-1.126 0-2.376-.184-2.376-1.966q0-1.784 3.122-2.044-.19-3.514 2.387-3.513c.23 0 .454.022.657.09l.654.18c.69-2.22 1.87-3.328 3.53-3.328 1.58 0 2.848 1.392 3.186 2.942zM11.54 5.556a3.7 3.7 0 0 0-.97-.14c-1.91 0-3.437 1.667-3.437 3.75v.167h-.077c-1.68 0-3.056 1.5-3.056 3.334C4 14.5 5.375 16 7.056 16H22.34c2.648 0 4.66-2.278 4.66-5.167 0-2.89-2.165-5.25-4.814-5.25a4.3 4.3 0 0 0-1.783.39C19.97 3.693 18.11 2 15.92 2c-2.063 0-3.82 1.5-4.38 3.556M4.32 20.66q-.828-.147-.828-.8T4.32 19h23.26q.804.138.804.84 0 .703-.803.82z"
}), /*#__PURE__*/React.createElement("text", {
  fontFamily: ".AppleSystemUIFont",
  fontSize: 8
}, /*#__PURE__*/React.createElement("tspan", {
  x: 5.338,
  y: 29
}, "BASE")))));
export default SvgChartCloudBase;